import { render, staticRenderFns } from "./ChangeMailFormDone.vue?vue&type=template&id=3b18a054&scoped=true&lang=pug"
import script from "./ChangeMailFormDone.vue?vue&type=script&lang=js"
export * from "./ChangeMailFormDone.vue?vue&type=script&lang=js"
import style0 from "./ChangeMailFormDone.vue?vue&type=style&index=0&id=3b18a054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18a054",
  null
  
)

export default component.exports